import WorkbenchCanvas from '@/appComponents/workbench/WorkbenchCanvas'
import {
  ON_CREATE_ACTION,
  RESET_STORE
} from '@/appLogic/workbench/common/store/actions'

export default {
  components: {
    WorkbenchCanvas
  },
  created () {
    const targetId = this.$route.params.id
    this.$store.dispatch('workbench/' + ON_CREATE_ACTION, {interface: this.interface, id: targetId})
  },
  destroyed () {
    this.$store.dispatch('workbench/' + RESET_STORE)
  }
}



// WEBPACK FOOTER //
// ./src/app/views/workbenchConvergence/mixin.js